import * as React from 'react';

import type {Tab} from '../control-bar/page-control-bar';

type Props = {
    selectedTab: string;
    tabOptions: Tab[];
};

export function TabbedContent(props: Props) {
    const {selectedTab, tabOptions} = props;
    const selectedTabContent = tabOptions.find((option) => option.id === selectedTab);

    return selectedTabContent && selectedTabContent.component ? (
        selectedTabContent.component
    ) : (
        <></>
    );
}
